/*
 * File: locale.slice.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 5, 2022 at 2:53 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';

// Constants
import { DEFAULT_LOCALE } from '../../../../Constants';


/**
 * Constants
 */

export const initialState = {
	status: 'idle',
	error: null,
	value: {
		isSet: false,
		localeId: DEFAULT_LOCALE,
		localeBaseId: DEFAULT_LOCALE.split('-')[0],
		localePath: ''
	},
};


/**
 * Slices
 */

export const localeSlice = createSlice({
	name: 'locale',
	initialState,
	reducers: {
		updateLocale: (state, action) => {

			// Set state
			state.value = {
				...action.payload,
				isSet: true
			};
		},
		clearLocale: (state) => {

			// Clear state
			state.value = {
				...initialState.value,
				isSet: true
			};
		},
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const { updateLocale, clearLocale } = localeSlice.actions;

export default localeSlice.reducer;
